import "../navigation.css";

import { Divider, Drawer as MuiDrawer, Stack } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { LanguageSelect } from "@/components/language-select";
import { ProductUpdateButton } from "@/features/product-update/product-update-button";
import { NAMESPACES } from "@/i18n/constants";
import { AccountSelect } from "../account-select";
import { AdminToolsNavList } from "../nav-links";
import { ProvideFeedbackButton } from "../provide-feedback-modal/provide-feedback-button";
import { AOISelect } from "./aoi-select";

interface DrawerProps {
    multipleAOI: boolean;
    loggedIn: boolean;
    open: boolean;
    onClose: () => void;
    mobileMenuAnchorSetter: (anchor: HTMLElement | null) => void;
    admin: boolean;
}

export function Drawer({ multipleAOI, loggedIn, open, onClose, mobileMenuAnchorSetter, admin }: DrawerProps) {
    const navigate = useNavigate();

    const { t } = useTranslation(NAMESPACES.FEATURES.NAVIGATION);

    return (
        <MuiDrawer anchor={"left"} keepMounted open={open} onClose={onClose} sx={{ zIndex: 1200, overflow: "hidden" }}>
            <Stack height={"100%"} flexDirection={"column"} overflow={"scroll"}>
                <Toolbar
                    style={{
                        minHeight: "var(--nav-bar-height, 55px)",
                        maxHeight: "var(--nav-bar-height)",
                    }}
                />
                <AccountSelect label={t("drawer.account")} />
                {multipleAOI && <AOISelect />}
                <Divider sx={{ mb: 2 }} />
                {admin && (
                    <div style={{ marginTop: 16 }}>
                        <MenuItem key={`admin-links-title`}>
                            <b>Admin Links</b>
                        </MenuItem>
                        {AdminToolsNavList.map((NL) => (
                            <MenuItem
                                key={`admin-links-${NL.url}`}
                                component={Link}
                                to={NL.url}
                                onClick={() => {
                                    mobileMenuAnchorSetter(null);
                                }}
                            >
                                {NL.name}
                            </MenuItem>
                        ))}
                    </div>
                )}
                {loggedIn && (
                    <div style={{ marginTop: "auto" }}>
                        <ProductUpdateButton buttonText={t("drawer.product-update-button")} />
                        <MenuItem
                            key={`NavBarStandardLinks/settings`}
                            component={Link}
                            to={"/settings"}
                            onClick={() => {
                                mobileMenuAnchorSetter(null);
                            }}
                        >
                            {t("nav-links.settings")}
                        </MenuItem>
                        <ProvideFeedbackButton />
                        <LanguageSelect flagSize={14} includeLabel={true} />
                        <MenuItem
                            key={`logout`}
                            onClick={() => {
                                const { search, hash } = window.location;
                                navigate(`/auth/logout${search}${hash}`);
                            }}
                        >
                            {t("nav-bar.log-out")}
                        </MenuItem>
                    </div>
                )}
            </Stack>
            <MenuItem
                sx={{
                    background: "#00000022",
                    width: "100%",
                }}
                onClick={onClose}
            >
                {t("drawer.back")}
            </MenuItem>
        </MuiDrawer>
    );
}
